import React from "react";
import { InputJson } from "nq-component";
import BaseFormPage from "../../../../../../base/BaseFormPage";
import CollectionFormPresenter from "../../../../../collection-form/CollectionFormPresenter";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import NavBar from "../../../../../../components/NavBar";
import FormFactory from "../../../../../../components/FormFactory";
import withRouter from "../../../../../../withRouter";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import FileUpload from "../../../../../../components/common/FileUpload";
import { createNotification } from "../../../../../../createNotification";
import MonetizationRequestFormPresenter from "./MonetizationRequestFormPresenter";
import InputFactory from "../../../../../../components/InputFactory";

class MonetizationRequestForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      employeeName: "",
      advanced: false,
      type: [],
      selectedType: "",
    };
    this.presenter = new MonetizationRequestFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const type = await findObjectUseCase().execute("leave_type", {
      where: { is_monetized: true },
    });
    this.setState({ type });
  }
  componentDidUpdate(prevProps, prevState) {
    const { object } = this.state;
    console.log("OBJECT: ", object);
    if (prevState.object !== object) {
      const employeeName = `${object?.employee?.Firstname} ${
        object?.employee?.Middlename || ""
      } ${object?.employee?.surname}`;
      this.setState({ employeeName, selectedType: object.selectedType });
    }
  }

  getCollectionName() {
    return "monetization_request";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  async handleApproveBtn() {
    this.presenter.DialogConfirmation("Recommending for Approval");
  }

  handleRejectBtn() {
    this.presenter.DialogConfirmation("Recommending for Disapproval");
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Approve";
    console.warn("OBJECT: ", object);
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleApproveBtn();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div>
                          <label>
                            <b>Employee Name: </b>
                            {this.state.employeeName}
                          </label>
                        </div>
                        {/* <div className="mb-4"> */}
                        <label className="fs-6">
                          Leave Type: <span className="text-danger">*</span>
                        </label>
                        <SearchSelect
                          required
                          value={this.state.selectedType}
                          // disabled={object.stats !== "Pending"}
                          onClickClear={() =>
                            this.onChangeForm("selectedType", "")
                          }
                          disabled={true}
                          onChange={(value) =>
                            this.onChangeForm("selectedType", value)
                          }
                          options={
                            // this.state.type
                            ["Sick Leave", "Vacation Leave"].map((type) => ({
                              label: type,
                              value: type,
                            }))
                          }
                        />
                        {/* </div> */}
                        <FormFactory
                          schema={schema}
                          object={object}
                          // disabled={object.stats !== "Pending"}
                          disabled={true}
                          onChange={this.onChange.bind(this)}
                          excludeFields={[
                            "selectedType",
                            "halfDay",
                            "employee",
                            "stats",
                            "selectedFiles",
                          ]}
                        />
                      </>
                    )}

                    <div className="mb-2">
                      <label className="mb-2 fs-6">Attachments</label>
                      <br></br>
                      <InputFactory
                        type="File"
                        onChange={(value) =>
                          this.onChangeForm("selectedFiles", value)
                        }
                        disabled={true}
                        value={object.selectedFiles}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    {object.stats === "Pending" && (
                      <>
                        <button
                          type="submit"
                          className="btn btn-primary fs-sm me-3"
                        >
                          <i className="bi bi-file-earmark-check me-2"></i>
                          {label}
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger fs-sm me-3"
                          onClick={() => this.handleRejectBtn()}
                        >
                          <i className="bi bi-x-square me-2"></i>
                          Disapproved
                        </button>
                      </>
                    )}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.navigateBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(MonetizationRequestForm);
